import React from 'react';
import './Hero.css';
import MainAnima from '../MainAnima/MainAnima';
import btnIcon from '../../assets/image/hero-btn.svg';
import { useTranslation } from 'react-i18next';

const Hero = () => {
  const { t } = useTranslation();

  return (
    <section className="hero">
      <div className="hero__container container">
        <div className="hero__left-block">
          <h1 className="hero__title">{t('cutting_edge_solutions')}</h1>
          <p className="hero__description">{t('helping_businesses')}</p>
          <a href="https://wa.me/+380956584268">
            <button className="hero__collab-btn">
              {t('lets_collaborate')}
              <img src={btnIcon} alt="" className="icon" />
            </button>
          </a>
        </div>
        <MainAnima />
      </div>
    </section>
  );
};

export default Hero;
